import ApiService from "./api";
const VATService = {
    checkVat: async function(vat){
        const url = `https://vat.erply.com/numbers?vatNumber=${vat}`;
        const data = {
            method:'get',
            url,
            headers:null
        };
        try {
            const response = await ApiService.customRequest(data);
            if(response.data) {
                return {status:true, data:response.data};
            }
        }
        catch(error){
            if(error.response.status === 503){
                return {status: false, data:error.response.data};
            }
            else{
                return false;
            }
        }
    }
};
export default VATService;